import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import doctor from "../images/doctorAvtar.png";
import { GiAlarmClock } from "react-icons/gi";
import { LiaCalendarCheckSolid } from "react-icons/lia";
import {  FaCalendarAlt, FaDownload } from "react-icons/fa";
import check from "../images/check.png";
import { useSelector, useDispatch } from "react-redux";
import { FaCheckCircle, FaTimesCircle, FaHourglassHalf,FaCheck} from "react-icons/fa";
import AppointmentPaymentReceipt from "../Appointments/AppointmentPaymentReciept";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import {
  setAppointmentList,
  setDoctorDetails,
  setPatientDetails,
} from "../reduxtool/action";
import axios from "axios";
import { decryptData } from "../Services/TabServices";

interface SplitInstrument {
  amount: number;
  rail:{
    type: string;
    utr: string;
    upiTransactionId: string;
    vpa: string;
  };
  instrument: {
    type: string;
    maskedAccountNumber:string;
    accountType: string;
    accountHolderName:  string;
    ifsc: string;
    bankId: string;
  };
}

interface PaymentDetail {
  paymentMode: string;
  transactionId: string;
  timestamp: number;
  amount: number;
  state: string;
  splitInstruments: SplitInstrument[];
}

interface PhonePeStatusResponse {
  orderId: string;
  state: string;
  amount: number;
  expireAt: number;
  paymentDetails: PaymentDetail[];
}

interface PatientInfo {
  name: string;
  gender: string;
  age: string;
}
interface Appointment {
  appointmentId: string;
  formatedDate: string;
  formatedTime: string;
  doctorName: string;
  specializationName: string;
  doctorFees: string;
   specialty?: string;
}

const PaymentSuccessPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tid=queryParams.get("tid");
 
  const token = sessionStorage.getItem("token");
    const storedUserId = sessionStorage.getItem("userId");
  const userId = storedUserId ? decryptData(storedUserId) : null;
  const navigate = useNavigate();
  const { bookingDate, doctorId, bookingTime, appointmentId } =
    location.state || {};
  const dispatch: any = useDispatch();
  const patient = useSelector((state: any) => state.userDetails);
  const doctorDetail = useSelector((state: any) => state.selectedDoctorDetails);
  const [age, setAge] = useState<any>("");
  const [cancelling, setCancelling] = useState(false);
  const [cancelMessage, setCancelMessage] = useState("Cancel Appointment");
  const [showCancelSuccess, setShowCancelSuccess] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [acknowledgeTerms, setAcknowledgeTerms] = useState(false);
  const [cancelError, setCancelError] = useState(""); 
  const [paymentDetails, setPaymentDetails] = useState<any>(null);
const [showReceipt, setShowReceipt] = useState(false);
const [appointment, setAppointment] = useState<Appointment | null>(null);
 const [isLoadingPaymentStatus, setLoadingPaymentStatus] = useState(false);
const [phonePeStatus, setPhonePeStatus] = useState<PhonePeStatusResponse | null>(null);
const [countdown, setCountdown] = useState(10);

const formatAppointmentDateTime = (appointmentDate: any, appointmentTime: any) => {
  if (!appointmentDate || !appointmentTime) {
    return { formattedDate: 'N/A', formattedTime: 'N/A' };
  }

  try {
    if (typeof appointmentDate !== 'string' || typeof appointmentTime !== 'string') {
      return { formattedDate: 'N/A', formattedTime: 'N/A' };
    }

    const trimmedDate = appointmentDate.trim();
    const trimmedTime = appointmentTime.trim();

    if (trimmedDate === '' || trimmedTime === '') {
      return { formattedDate: 'N/A', formattedTime: 'N/A' };
    }

    // Parse the date in DD-MM-YYYY format
    const [day, month, year] = trimmedDate.split('-');

    if (!day || !month || !year) {
      return { formattedDate: 'N/A', formattedTime: 'N/A' };
    }

    // Build ISO string: YYYY-MM-DDTHH:mm:ss
    const dateTimeString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${trimmedTime}:00`;

    const appointmentDateTime = new Date(dateTimeString);

    if (isNaN(appointmentDateTime.getTime())) {
      return { formattedDate: 'N/A', formattedTime: 'N/A' };
    }

    const formattedDate = appointmentDateTime.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    const formattedTime = appointmentDateTime.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    return { formattedDate, formattedTime };
  } catch (error) {
    console.error('Error formatting appointment date/time:', error);
    return { formattedDate: 'N/A', formattedTime: 'N/A' };
  }
};




const { formattedDate, formattedTime } = formatAppointmentDateTime(
  paymentDetails?.appointmentDate,
  paymentDetails?.appointmentTime
);



useEffect(() => {
  const fetchPhonePePaymentStatus = async () => {
    try {
      setLoadingPaymentStatus(true);
      
    
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/phonepe/status/${tid}`
      );
      setPhonePeStatus(response.data);

     
      let timeLeft = 10;
      const countdownInterval = setInterval(() => {
        timeLeft -= 1;
        setCountdown(timeLeft);
        if (timeLeft <= 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);

      // Poll second API every 2 seconds
      const pollPaymentStatus = setInterval(async () => {
        try {
          const response2 = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/Payment/status/${tid}`
          );
        
          if (response2.status === 200 && response2.data) {
            setPaymentDetails(response2.data);
            const paymentDetails = response2.data;
let { formattedDate, formattedTime } = formatAppointmentDateTime(
  paymentDetails.appointmentDate, 
  paymentDetails.appointmentTime   
);
            if (response2.data?.patientId) {
              dispatch(
                setPatientDetails(sessionStorage.getItem("token"), response2.data.patientId)
              );
            }
            if (response2.data?.doctorId) {
              dispatch(setDoctorDetails(response2.data.doctorId));
            }
            
           
            clearInterval(pollPaymentStatus);
            clearInterval(countdownInterval);
            setLoadingPaymentStatus(false);
          }
        } catch (error) {
          console.error("Error polling payment details:", error);
         
        }
      }, 2000); 

      return () => {
        clearInterval(countdownInterval);
        clearInterval(pollPaymentStatus);
      };
    } catch (error) {
      console.error('Error fetching PhonePe payment status:', error);
      setLoadingPaymentStatus(false);
    }
  };

  if (tid) fetchPhonePePaymentStatus();
}, [tid, dispatch]);


  // useEffect(() => {
  //   const fetchPaymentDetails = async () => {
  //   
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/api/Payment/status/${tid}`
  //       );
  //       setPaymentDetails(response.data);
  //      if (response.data?.patientId) {
  //           dispatch(
  //             setPatientDetails(sessionStorage.getItem("token"), response.data.patientId)
  //           );
  //         }
  //         if (response.data?.doctorId) {
  //           dispatch(setDoctorDetails(response.data.doctorId));
  //         }
  //     } catch (error) {
  //       console.error("Error fetching payment details:", error);
  //     } finally {
  //     }
  //   };

  //   if (tid) fetchPaymentDetails();
  // }, [tid, token, dispatch]);

useEffect(() => {
  if (phonePeStatus?.state === 'FAILED'||phonePeStatus?.state === 'PENDING') {
    const timer = setTimeout(() => {
      navigate('/doctors');
    }, 10000);
    return () => clearTimeout(timer);
  }
}, [phonePeStatus?.state, navigate]);

  useEffect(() => {
    if (token && userId) {
      dispatch(setPatientDetails(token, userId));
    }
  }, [dispatch, token, userId]);

  useEffect(() => {
    if (doctorId) {
      dispatch(setDoctorDetails(doctorId));
    }
  }, [dispatch, doctorId]);

  useEffect(() => {
    if (patient?.dob) {
      const calculatedAge = calculateAge(patient.dob);
      setAge(calculatedAge);
    }
  }, [patient]);
  useEffect(() => {
  const handleBack = () => {
    window.location.replace("/");
  };

  window.history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", handleBack);
  return () => {
    window.removeEventListener("popstate", handleBack);
  };
}, []);


const calculateAge = (dobString: string): string => {
  if (!dobString) return "";
  const dob = new Date(dobString);
  const today = new Date();

  let years = today.getFullYear() - dob.getFullYear();
  let months = today.getMonth() - dob.getMonth();
  let days = today.getDate() - dob.getDate();

  if (days < 0) {
    months -= 1;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Always show years, months, and days
  return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''} ${days} day${days !== 1 ? 's' : ''}`;
};




const fetchAppointmentStatus = async () => {
  setCancelling(true);
  setCancelMessage("Cancelling Appointment...");

  const payload = {
    id: paymentDetails.appointmentId,
  //  id: 6394,
    UserId: userId,
    UserTypeId: "P",
    Reason: "",
    Remark: ""
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/appointments/CancelAppointment`,
    {}, // <-- send payload here
      {  params: payload,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch(setAppointmentList());
    setShowCancelSuccess(true);

    setTimeout(() => {
      navigate("/");
    }, 3000);

  } catch (error: any) {
    console.error("Error fetching appointment status:", error?.message);
    setCancelError("Failed to cancel appointment. Please try again.");
  } finally {
    setCancelling(false);
  }
};

 // ⬇️ Remove the old useEffect where you set appointment immediately

useEffect(() => {
  if (paymentDetails && doctorDetail.length > 0) {
    const { formattedDate, formattedTime } = formatAppointmentDateTime(
      paymentDetails?.appointmentDate,
      paymentDetails?.appointmentTime
    );

    const appointmentData: Appointment = {
      appointmentId: paymentDetails.appointmentId,
      formatedDate: formattedDate||"",               
      formatedTime: formattedTime||"",              
      doctorName: doctorDetail[0]?.doctorName || "",
      specializationName: doctorDetail[0]?.specializationName || "",
      doctorFees: doctorDetail[0]?.doctorFees || "",
      specialty: doctorDetail[0]?.specialty || "General",
    };

    setAppointment(appointmentData);
  }
}, [paymentDetails, doctorDetail]);

useEffect(() => {
  window.history.replaceState(null, "", window.location.href);

  const handleBackNavigation = () => {
    
    window.location.replace("/");
  };

  window.addEventListener("popstate", handleBackNavigation);

  return () => {
    window.removeEventListener("popstate", handleBackNavigation);
  };
}, []);

// Map Redux state to patientInfo
const patientInfo: PatientInfo = {
  name: patient?.patientName || "",
  gender: patient?.gender || "",
  age: calculateAge(patient?.dob || ""),
};

  return (
<div>



{isLoadingPaymentStatus ?(
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 w-[95%] max-w-lg max-h-[90vh] overflow-y-auto">
      <div className="flex justify-center mb-6">
       <div
      className={`
        w-20 h-20 rounded-full flex items-center justify-center shadow-lg
        ${phonePeStatus?.state === 'COMPLETED' ? 'bg-gradient-to-br from-green-400 to-green-600 animate-pulse' : ''}
        ${phonePeStatus?.state === 'FAILED'    ? 'bg-red-400 animate-pulse' : ''}
        ${phonePeStatus?.state === 'PENDING'   ? 'bg-yellow-400 animate-pulse' : ''}
      `}
    >
      {phonePeStatus?.state === 'COMPLETED' && (
        <FaCheck className="w-10 h-10 text-white" />
      )}
      {phonePeStatus?.state === 'FAILED' && (
        <FaTimesCircle className="w-10 h-10 text-white" />
      )}
      {phonePeStatus?.state === 'PENDING' && (
        <FaHourglassHalf className="w-10 h-10 text-white" />
      )}
    </div>
      </div>

  
      <div className="text-center mb-6">
        {/* <div className="inline-flex px-4 py-1.5 rounded-full bg-green-100 text-green-700 font-semibold text-sm mb-3">
          {phonePeStatus?.state}
        </div> */}
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Payment  {phonePeStatus?.state}
        </h2>
        <p className="text-gray-600 text-sm">
          Your payment has been processed {phonePeStatus?.state}
        </p>
      </div>

    

     

     

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 overflow-hidden">
        <div
          className="bg-[#184A84] h-2.5 rounded-full transition-all duration-1000 ease-linear"
          style={{ width: `${((10 - countdown) / 10) * 100}%` }}
        ></div>
      </div>

   
     {/* Countdown Text */}
<div className="text-center">
  {phonePeStatus?.state === 'COMPLETED' && (
    <p className="text-gray-600 text-sm mb-2">
      Redirecting to appointment details in{' '}
      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white font-bold text-lg mx-1">
        {countdown}
      </span>{' '}
      {countdown === 1 ? 'second' : 'seconds'}...
    </p>
  )}

  {phonePeStatus?.state === 'FAILED' && (
    <p className="text-red-600 text-sm mb-2">
      Payment failed. Returning to booking page in{' '}
      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-red-600 text-white font-bold text-lg mx-1">
        {countdown}
      </span>{' '}
      {countdown === 1 ? 'second' : 'seconds'}...
    </p>
  )}

  {phonePeStatus?.state === 'PENDING' && (
    <p className="text-yellow-600 text-sm mb-2">
      Payment pending. Checking status in{' '}
      <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-yellow-600 text-white font-bold text-lg mx-1">
        {countdown}
      </span>{' '}
      {countdown === 1 ? 'second' : 'seconds'}...
    </p>
  )}
</div>

    </div>
  </div>
    ):( <div className="flex flex-col items-center min-h-[400px] w-full px-2 sm:px-4 mt-5">
      {showCancelConfirmation && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md">
            <h2 className="text-xl font-semibold text-[#333] mb-4 text-center">
              Cancel Appointment?
            </h2>
            <div className="flex flex-col sm:flex-row items-center gap-4 mb-4 border rounded-lg p-4 shadow-inner">
             
             <div  className="w-16 h-16 rounded-full "> <img
                src={
                  doctorDetail[0]?.doctorImage
                    ? `${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`
                    : doctor
                }
                alt="doctor"
                className="w-full object-cover"
              />
              </div>
              <div className="flex flex-col items-center sm:items-start">
                <p className="font-semibold text-[#333] text-center sm:text-left">
                  {doctorDetail[0]?.doctorName}
                </p>
                <p className="text-xs text-[#606060] text-start sm:text-left">
                  {doctorDetail[0]?.specializationName}
                </p>
                <p className="text-xs text-[#184A84]  text-start sm:text-left">
                  {doctorDetail[0]?.location}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-4">
              <div className="flex items-center justify-center gap-2 bg-[#f5f5f5] rounded-lg py-2 px-3">
                <LiaCalendarCheckSolid className="text-xl text-[#009A85]" />
                <div>
                  <p className="text-[11px] text-[#606060] text-center">Date</p>
                  <p className="text-[#009A85] text-[12px] font-semibold">
                    {/* {formattedDate} */}
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-center gap-2 bg-[#f5f5f5] rounded-lg py-2 px-3">
                <GiAlarmClock className="text-xl text-[#009A85]" />
                <div>
                  <p className="text-[11px] text-[#606060] text-center">Time</p>
                  <p className="text-[#009A85] text-[12px] font-semibold">
                    {/* {formattedTime} */}
                  </p>
                </div>
              </div>
            </div>

            <p className="text-sm text-[#606060] text-center mb-4">
              Are you sure you want to cancel this appointment?
            </p>
            <div className="flex items-center gap-2 mb-4">
              <input
                type="checkbox"
                id="terms"
                checked={acknowledgeTerms}
                onChange={(e) => setAcknowledgeTerms(e.target.checked)}
                className="w-3  h-3"
              />
              <label htmlFor="terms" className="text-xs">
                I agree to the{"  "}
                <Link
                  to="/terms_conditions"
                  className="text-xs text-[#009A85] underline"
                >
                  terms and conditions
                </Link>
              </label>
            </div>
            <div className="flex flex-col items-center gap-2 mt-4 w-full">
              <div className="flex justify-center gap-4">
                <button
                  onClick={() => setShowCancelConfirmation(false)}
                  className="px-4 py-2 text-sm bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition"
                >
                  No, Keep
                </button>
                <button
                  disabled={cancelling || !acknowledgeTerms}
                  onClick={fetchAppointmentStatus}
                  className={`px-4 py-2 text-sm rounded transition text-white ${
                    cancelling || !acknowledgeTerms
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-red-500 hover:bg-red-600"
                  }`}
                >
                  {cancelling ? "Cancelling..." : "Cancel Appointment"}
                </button>
              </div>

              {/* Error message below button */}
              {cancelError && (
                <p className="text-xs text-red-500 mt-2">{cancelError}</p>
              )}
            </div>
          </div>
        </div>
      )}
 {showReceipt && appointment && (
   <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
    {/* Mobile View */}
    <div className="block md:hidden relative bg-white rounded-2xl shadow-2xl w-full max-w-sm max-h-[80vh] overflow-hidden">
      
      {/* Mobile Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Payment Receipt</h3>
            <p className="text-xs text-gray-600">Invoice Details</p>
          </div>
        </div>
        
        {/* Mobile Close Button */}
        <button
          onClick={() => setShowReceipt(false)}
          className="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-all duration-200"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Mobile Receipt Details */}
      <div className="p-6 space-y-6">
        {/* Patient Information */}
        <div className="bg-gray-50 rounded-xl p-4">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            Patient Details
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Name:</span>
              <span className="font-medium text-gray-900">{patient?.patientName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Phone:</span>
              <span className="font-medium text-gray-900">{patient?.phoneNo}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Email:</span>
              <span className="font-medium text-gray-900">{patient?.email || 'N/A'}</span>
            </div>
          </div>
        </div>

        {/* Appointment Information */}
        <div className="bg-gray-50 rounded-xl p-4">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 9l6 6m0 0l6-6m-6 6V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h6z" />
            </svg>
            Appointment Info
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Date:</span>
              <span className="font-medium text-gray-900">{appointment?.formatedDate}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Time:</span>
              <span className="font-medium text-gray-900">{appointment?.formatedTime}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Doctor:</span>
              <span className="font-medium text-gray-900">{appointment?.doctorName}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Department:</span>
              <span className="font-medium text-gray-900">{appointment?.specializationName}</span>
            </div>
          </div>
        </div>

        {/* Payment Information */}
        <div className="bg-teal-50 rounded-xl p-4 border border-teal-100">
          <h4 className="font-semibold text-gray-900 mb-3 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Payment Details
          </h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Amount:</span>
              <span className="font-bold text-teal-600 text-lg">₹{appointment?.doctorFees}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Payment ID:</span>
              <span className="font-medium text-gray-900">{appointment?.appointmentId}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Status:</span>
              <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                Paid
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Download Button */}
      <div className="p-6 pt-0">
        <PDFDownloadLink
          document={
            <AppointmentPaymentReceipt
              appointment={appointment}
              onClose={() => setShowReceipt(false)}
              patientInfo={patientInfo}
            />
          }
          fileName={`${patient?.patientName}-Invoice.pdf`}
        >
          {({ loading }) => (
            <button className="w-full py-4 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-base transition-all duration-200 shadow-lg active:scale-95 flex items-center justify-center space-x-2">
              {loading ? (
                <>
                  <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                  <span>Preparing...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Download Invoice</span>
                </>
              )}
            </button>
          )}
        </PDFDownloadLink>
      </div>

      {/* Mobile Footer */}
      <div className="px-6 pb-6">
        <div className="flex items-center justify-center space-x-2 text-xs text-gray-500 bg-gray-50 rounded-lg p-3">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Download to view complete invoice details</span>
        </div>
      </div>
    </div>

    {/* Tablet View */}
    <div className="hidden md:block lg:hidden relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
      
      {/* Tablet Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Payment Receipt</h3>
            <p className="text-sm text-gray-600">Invoice for {patient?.patientName}</p>
          </div>
        </div>
        
        {/* Tablet Close Button */}
        <button
          onClick={() => setShowReceipt(false)}
          className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-200 hover:shadow-md"
        >
          <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Tablet Receipt Details */}
      <div className="p-8">
        <div className="grid grid-cols-2 gap-6 mb-8">
          {/* Patient Information */}
          <div className="bg-gray-50 rounded-xl p-5">
            <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Patient Details
            </h4>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Name:</span>
                <span className="font-medium text-gray-900">{patient?.patientName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Phone:</span>
                <span className="font-medium text-gray-900">{patient?.phoneNo}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Email:</span>
                <span className="font-medium text-gray-900">{patient?.email || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Appointment Information */}
          <div className="bg-gray-50 rounded-xl p-5">
            <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
              <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3a2 2 0 012-2h4a2 2 0 012 2v4m-6 9l6 6m0 0l6-6m-6 6V9a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h6z" />
              </svg>
              Appointment Info
            </h4>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Date:</span>
                <span className="font-medium text-gray-900">{appointment?.formatedDate}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Time:</span>
                <span className="font-medium text-gray-900">{appointment?.formatedTime}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Doctor:</span>
                <span className="font-medium text-gray-900">{appointment?.doctorName}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Department:</span>
                <span className="font-medium text-gray-900">{appointment?.specializationName}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Payment Information - Full Width */}
        <div className="bg-teal-50 rounded-xl p-6 border border-teal-100 mb-8">
          <h4 className="font-semibold text-gray-900 mb-4 flex items-center">
            <svg className="w-5 h-5 mr-2 text-teal-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Payment Details
          </h4>
          <div className="grid grid-cols-3 gap-6 text-sm">
            <div className="text-center">
              <span className="block text-gray-600 mb-1">Amount</span>
              <span className="font-bold text-teal-600 text-xl">₹{appointment?.doctorFees}</span>
            </div>
            <div className="text-center">
              <span className="block text-gray-600 mb-1">Payment ID</span>
              <span className="font-medium text-gray-900">{appointment?.appointmentId}</span>
            </div>
            <div className="text-center">
              <span className="block text-gray-600 mb-1">Status</span>
              <span className="inline-flex px-3 py-1 text-sm font-semibold rounded-full bg-green-100 text-green-800">
                Paid
              </span>
            </div>
          </div>
        </div>

        {/* Tablet Download Button */}
        <PDFDownloadLink
          document={
            <AppointmentPaymentReceipt
              appointment={appointment}
              onClose={() => setShowReceipt(false)}
              patientInfo={patientInfo}
            />
          }
          fileName={`${patient?.patientName}-Invoice.pdf`}
        >
          {({ loading }) => (
            <button className="w-full py-4 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-base transition-all duration-200 shadow-lg hover:shadow-xl flex items-center justify-center space-x-2">
              {loading ? (
                <>
                  <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                  </svg>
                  <span>Preparing...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Download Invoice</span>
                </>
              )}
            </button>
          )}
        </PDFDownloadLink>
      </div>

      {/* Tablet Footer */}
      <div className="px-8 pb-8">
        <div className="flex items-center justify-center space-x-2 text-sm text-gray-500 bg-gray-50 rounded-lg p-4">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Download PDF to view complete invoice with official letterhead</span>
        </div>
      </div>
    </div>

    {/* Desktop View */}
    <div className="hidden lg:block relative bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
      {/* Desktop Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-100 bg-gradient-to-r from-teal-50 to-teal-100">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Payment Receipt</h3>
            <p className="text-sm text-gray-600">Invoice for {patient?.patientName}</p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          {/* Desktop Download Button */}
          <PDFDownloadLink
            document={
              <AppointmentPaymentReceipt
                appointment={appointment}
                onClose={() => setShowReceipt(false)}
                patientInfo={patientInfo}
              />
            }
            fileName={`${patient?.patientName}-Invoice.pdf`}
          >
            {({ loading }) => (
              <button className="px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-xl font-semibold text-sm transition-all duration-200 shadow-lg hover:shadow-xl flex items-center space-x-2">
                {loading ? (
                  <>
                    <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                    </svg>
                    <span>Preparing...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Download Invoice</span>
                  </>
                )}
              </button>
            )}
          </PDFDownloadLink>
          
          {/* Desktop Close Button */}
          <button
            onClick={() => setShowReceipt(false)}
            className="w-10 h-10 bg-gray-100 hover:bg-gray-200 rounded-xl flex items-center justify-center transition-all duration-200 hover:shadow-md"
          >
            <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Desktop Content Area */}
      <div className="flex h-[calc(90vh-140px)]">
        
       

        {/* Right Side - PDF Viewer */}
        <div className="flex-1 bg-gray-50">
          <div className="w-full h-full p-4">
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 h-full overflow-hidden">
              <PDFViewer className="w-full h-full border-0 rounded-xl">
                <AppointmentPaymentReceipt
                  appointment={appointment}
                  onClose={() => setShowReceipt(false)}
                  patientInfo={patientInfo}
                />
              </PDFViewer>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Footer */}
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-100">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Receipt generated successfully • All payments are secure</span>
          </div>
          <div className="text-xs text-gray-400">
            Generated on {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  </div>
)}

      {showCancelSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] sm:w-[400px] text-center">
            <img src={check} alt="Success" className="w-8 h-8 mx-auto mb-4" />
            <p className="text-lg font-semibold ">Appointment Cancelled</p>
            <p className="text-sm mt-2">
              Your appointment has been successfully cancelled.
            </p>
          </div>
        </div>
      )}




      <div className=" w-[100%] sm:w-[85%] md:w-[80%] lg:w-[70%] xl:w-[60%]">
   {/* ✅ Payment Status UI */}
{paymentDetails && (
  <div className="bg-[#F8F8F8] p-6 sm:p-10 rounded-xl shadow-md text-center">
    <div className="flex justify-center mb-4">
 
  {paymentDetails.status === "SUCCESS" && (
    <img src={check} alt="Success" className="w-10 h-10" />
  )}

  
  {paymentDetails.status === "PENDING" && (
    <FaHourglassHalf className="text-yellow-500 w-10 h-10" />
  )}

 
  {paymentDetails.status === "FAILED" && (
    <FaTimesCircle className="text-red-600 w-10 h-10" />
  )}
</div>

    {paymentDetails?.status === "SUCCESS" && (
      <>
        <p className="font-semibold text-xl text-green-600">
          Your Appointment is Confirmed!
        </p>
        <p className="text-sm text-[#606060] mt-1">
          Thank you for booking with{" "}
          <span className="font-semibold">Rama Hospital</span>
        </p>
      </>
    )}

    {paymentDetails?.status === "PENDING" && (
      <>
        <p className="font-semibold text-xl text-yellow-600">
          Your Payment is Pending
        </p>
        <p className="text-sm text-[#606060] mt-1">
          Please wait while we confirm your appointment.
        </p>
      </>
    )}

    {paymentDetails?.status === "FAILED" && (
      <>
        <p className="font-semibold text-xl text-red-600">
          Payment Failed
        </p>
        <p className="text-sm text-[#606060] mt-1">
          Unfortunately, your payment could not be processed. Please try again.
        </p>
      </>
    )}

    {/* ✅ Transaction ID (if available) */}
    {paymentDetails?.merchantTxnNo && (
      <p className="text-xs text-gray-600 mt-3 border-t pt-2">
        <span className="font-semibold">Transaction ID:</span>{" "}
        {paymentDetails?.merchantTxnNo}
      </p>
    )}
  </div>
)}


        <p className="mt-3 text-[#606060] text-[14px] mb-1 font-semibold">
          Appointment Details
        </p>
        <div className="bg-[#F8F8F8] p-2 sm:p-10">
          <div className="flex flex-col xs:flex-row justify-between gap-2">
            <div className=" flex justify-between items-center bg-white w-[99%] xs:w-[48%] px-4 xs:px-10 py-2">
              <div>
                <img
                  src={
                    doctorDetail[0]?.doctorImage
                      ? `${process.env.REACT_APP_BASE_URL}/${doctorDetail[0]?.doctorImage}`
                      : doctor
                  }
                  alt={doctor}
                  className="w-[80px] h-[80px] rounded-full"
                />
              </div>
              <div className="">
                <p className="font-semibold">{doctorDetail[0]?.doctorName}</p>
                <p className="text-[12px] text-start text-[#606060]">
                  {doctorDetail[0]?.specializationName}
                </p>
                <p className="text-[12px] text-start text-[#184A84] ">
                  {doctorDetail[0]?.location}
                </p>
              </div>
            </div>
            <div className="w-[99%] xs:w-[48%]">
              <div className="flex justify-between px-2 xs:px-10 py-2 items-center bg-white rounded-xl">
                <LiaCalendarCheckSolid className="text-2xl" />
                <div>
                  <p className="text-[12px] text-[#606060] text-center">Date</p>
                  <p className="text-[#009A85] text-[12px] font-semibold">
                    {formattedDate}
                  </p>
                </div>
              </div>
              <div className="flex justify-between px-2 xs:px-10 py-2 items-center bg-white rounded-xl mt-2">
                <GiAlarmClock className="text-2xl" />
                <div>
                  <p className="text-[12px] text-[#606060] text-center ">
                    Time
                  </p>
                  <p className="text-[#009A85] text-[12px] font-semibold">
                    {formattedTime}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-between bg-white mt-5 sm:px-5 py-2">
            <p className="font-semibold text-[14px]">Mode of Appointment</p>

            <p className="bg-[#009A85] p-1 text-white text-[12px] rounded-lg px-2">
              Video Consultation
            </p>
          </div>
        </div>
        <p className="mt-3 text-[#606060] text-[14px] mb-1 font-semibold">
          Patient Details
        </p>
        <div className="bg-[#F8F8F8] px:1 sm:px-10 py-3">
          <div className="flex justify-between gap-2 w-[100%]">
            <div className=" flex justify-between bg-white px-2 sm:px-5 py-2 w-[49%]">
              <p className="text-[#606060] text-[14px]">Name</p>
              <p className="font-semibold text-[14px]">{patient?.patientName}</p>
            </div>
            <div className=" flex justify-between bg-white px-2 sm:px-5 py-2  w-[49%]">
              <p className="text-[#606060] text-[14px]">Age</p>
              <p className="  text-[12px] sm:text-[14px]">{age}</p>
            </div>
          </div>
        </div>
        <p className="mt-3 text-[#606060] text-[14px] mb-1 font-semibold">
          Payment Details
        </p>
        <div className="flex justify-center items-center bg-[#F8F8F8] px-2 sm:px-10 py-5 w-full ">
          <div className="w-[100%]">
            <div className=" flex justify-between bg-white px-5 py-1 w-[100%] border-b-2">
              <p className=" font-semibold">Consultation Fees</p>
              <p className="font-semibold">₹{doctorDetail[0]?.doctorFees}</p>
            </div>
            <div className=" flex justify-between bg-white px-5 py-1 w-[100%] border-b-2">
              <p className=" font-semibold">Tax (GST)</p>
              <p className="font-semibold">₹0</p>
            </div>
            <div className=" flex justify-between bg-white px-5 py-1 w-[100%]  border-b-2">
              <div className="flex items-center gap-3">
                <p className=" font-semibold">Total Paid</p>
                <img src={check} alt="" className="w-4 h-4" />
              </div>
              <p className="font-semibold">₹{doctorDetail[0]?.doctorFees}</p>
            </div>
          </div>
        </div>
        <div className=" flex justify-center items-center py-5 w-full">
          <div className="flex flex-row justify-around gap-3 w-full xs:w-[70%] sm:w-full">
            <button
              className={`flex items-center gap-2 px-4 py-2 rounded-lg shadow-md text-white transition ${
                cancelling
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#FF0004] hover:bg-red-600"
              }`}
              disabled={cancelling}
              onClick={() => setShowCancelConfirmation(true)}
            >
              Cancel Appointment
            </button>
           <button
  onClick={() => appointment && setShowReceipt(true)}
  className="px-4 py-2 bg-[#184A84] text-white rounded shadow hover:bg-[#143b6b]"
>
Download Invoice
</button>
            <button
              className="flex items-center gap-2 px-4 py-2 rounded-lg shadow-md text-white bg-[#184A84] hover:bg-[#143b6b] transition"
              onClick={() => navigate("/")}
            >
              Go Home
            </button>
          </div>
        </div>
      </div>
    </div>)}


    
    
    </div>




   
  );
};

export default PaymentSuccessPage;
